import { Activity, Flame, Lock } from "lucide-react";
import React from "react";
import { FeatureCard } from "./FeatureCard.tsx";

export const MethodologySection: React.FC = () => {
  return (
    <section
      id="methodology"
      className="py-32 px-6 bg-zinc-900/30 border-t border-white/5 relative overflow-hidden"
    >
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-primary/5 to-transparent" />

      <div className="container mx-auto max-w-5xl relative z-10">
        <div className="mb-20 border-l-2 border-primary pl-6">
          <h2 className="text-4xl md:text-6xl font-heading font-bold mb-4 text-white">
            The Mirror
          </h2>
          <p className="text-xl text-zinc-400 max-w-2xl">
            Our engine reflects your social impact back to you, helping you understand the signals you're sending.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <FeatureCard
            icon={Activity}
            iconColor="bg-primary/10 text-primary"
            title="Impact Feedback"
            description="Don't just guess. See the data on how your communication lands. Understand the spark you create."
          />

          <FeatureCard
            icon={Lock}
            iconColor="bg-blue-500/10 text-blue-400"
            title="Pattern Recognition"
            description="Identify the subtle habits that might be creating distance. Awareness is the first step to change."
          />

          <FeatureCard
            icon={Flame}
            iconColor="bg-white/10 text-white"
            title="Calibration"
            description="Learn to adjust your energy. Find the balance between intensity and ease, warmth and mystery."
          />
        </div>
      </div>
    </section>
  );
};
